 <template>
 <div class="collection">
  <div v-for="paytype in payTypeList">
   <local-remittance
     :bank-info="bankInfo"
     :key = "componentKey"
     @ajax-success="localAjaxSuccess"
     v-if="paytype.id == 4 &&paytype.status == 0"
   ></local-remittance>
   <bar-info
     bar-title="USDT"
     :channel-info="usdtInfo"
     @ajax-success="ajaxSuccess"
     v-if="paytype.id == 5 &&paytype.status == 0"
   ></bar-info>
   <bar-info
     bar-title="ChipPay"
     :channel-info="otcInfo"
     @ajax-success="ajaxSuccess"
     v-if="paytype.id == 6 &&paytype.status == 0"
   ></bar-info>
   </div>
 </div>
</template>

<script>
import barInfo from "@/components/myFiles/collection/barInfo";
import { mapGetters } from 'vuex';
import {getCustPayTypes} from '@/api/user.js';
import localRemittance from "@/components/myFiles/collection/localRemittance";
import { queryTPayType } from '@/api/userCenter'
export default {
  name: "index",
  components:{
    localRemittance,
    barInfo,
  },
  data() {
    return {
      bankInfo:{},
      usdtInfo: {},
      otcInfo:{},
      payTypeList:[],
      componentKey:999
    }
  },
  created() {
    this.getPayType();
  },
  computed: {
    ...mapGetters(['userInfo','custPayTypes']),
  },
  watch: {
    custPayTypes: {
      handler(newVal) {
        if (newVal) {
          this.queryPayTypes();
        }
      },
      immediate: true
    }
  },
  methods: {
    queryTPayType,
    getPayType(){
      queryTPayType({
        oprType: 2,
      }).then((res) => {
        this.payTypeList = res.data;
      })
    },
    queryPayTypes(){
      const data = this.custPayTypes;
      if (data) {
        for (let i = 0; i < data.length; i++) {
          if(data[i].payTypeId == 4){
            this.bankInfo = data[i];
          }
          if(data[i].payTypeId == 5){
            this.usdtInfo = data[i];
          }
          if(data[i].payTypeId == 6){
            this.otcInfo = data[i];
          }
          this.componentKey ++;
        }
      }
    },
    ajaxSuccess(){
      this.queryPayTypes();
    },
    localAjaxSuccess(){
      this.queryPayTypes();
    }
  },
}
</script>

<style lang="scss">
.collection {
  .data-line {
    .text-box {
      display: inline-block;
      padding-right: 10px;
    }
  }
}
</style>
